import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import TalksListing from 'views/admin/talks/TalksListing'

const TalksPage = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <TalksListing />
      </Route>
    </Switch>
  )
}

export default TalksPage
